import {
  FC, useRef, useState, type RefObject,
} from 'react';
import InputLocation from 'src/common/components/Search/Inputs/InputLocation';
import LocationAutocompleteList from 'src/common/components/Search/LocationAutocompleteList';
import classNames from 'classnames/bind';
import type { SearchRefs } from 'src/common/components/Search/SearchInputProvider';
import type { SearchHeroVariant } from 'src/common/components/Search/types';
import { useSearchHeroModalContext } from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import useOnWindowWidthChange from 'src/common/hooks/useOnWindowWidthChange';
import styles from '../PopoverInputs.module.scss';

const cx = classNames.bind(styles);

type PopoverLocationInputProps = {
  refs: SearchRefs;
  variant?: SearchHeroVariant;
  className?: string;
  rootRef?: RefObject<HTMLDivElement>;
};

const PopoverLocationInput: FC<PopoverLocationInputProps> = ({
  refs, variant, className, rootRef,
}) => {
  const modal = useSearchHeroModalContext();
  const popoverRef = useRef<HTMLDivElement>(null);
  const [maxWidth, setMaxWidth] = useState<string | number>('auto');

  /** Popover should never exceed window bounds, but is positioned relatively to inputs */
  useOnWindowWidthChange(() => {
    let width;
    if (variant === 'hero') {
      // width should equal width of inputs wrapper
      width = rootRef?.current?.getBoundingClientRect().width;
    } else if (variant === 'navigation') {
      // full remaining viewport width
      const left = refs.inputs.current?.getBoundingClientRect().left;

      if (left) {
        width = window.innerWidth - left;
      }
    }
    setMaxWidth(width ?? null);
  });

  return (
    <div className={className}>
      <InputLocation refs={refs} variant={variant} popoverRef={popoverRef} />
      <div className={cx(styles.popovers, `${variant}Variant`, { active: modal.active === 'location' })}>
        <div
          className={cx(styles.location, `${variant}Variant`)}
          style={maxWidth ? { maxWidth } : {}}
        >
          <LocationAutocompleteList refs={refs} variant={variant} popoverRef={popoverRef} />
        </div>
      </div>
    </div>
  );
};

export default PopoverLocationInput;
